import { Link, NavLink, useNavigate } from 'react-router-dom';

export function Shell({ children, narrow = false }) {
  return (
    <div className="shell">
      <Header />
      <main className={narrow ? 'shell-main shell-narrow' : 'shell-main'}>{children}</main>
      <footer className="shell-footer">
        <span>MindReadir Press Engine</span>
        <span>Draft-only · Adam approves every send</span>
      </footer>
    </div>
  );
}

function Header() {
  const navigate = useNavigate();
  async function logout() {
    await fetch('/api/me', { method: 'DELETE', credentials: 'include' }).catch(() => {});
    navigate('/login', { replace: true });
  }
  return (
    <header className="shell-header">
      <div className="shell-header-inner">
        <Link to="/" className="brand">
          <span className="brand-mark">M</span>
          <span>MindReadir</span>
        </Link>
        <nav className="nav">
          <NavLink to="/" end>Command</NavLink>
          <NavLink to="/queue">Approval queue</NavLink>
          <NavLink to="/prospects">Prospects</NavLink>
        </nav>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
          <Link to="/prospects/new" className="btn btn-sm">+ Add prospect</Link>
          <button onClick={logout} className="btn btn-ghost btn-sm" title="Sign out">Sign out</button>
        </div>
      </div>
    </header>
  );
}

export function PageHeader({ eyebrow, title, sub, right }) {
  return (
    <div className="row row-between" style={{ alignItems: 'flex-end', marginBottom: 'var(--space-8)', gap: 'var(--space-6)' }}>
      <div>
        {eyebrow ? <div className="page-eyebrow">{eyebrow}</div> : null}
        <h1 className="page-title">{title}</h1>
        {sub ? <p className="page-sub">{sub}</p> : null}
      </div>
      {right ? <div className="row row-tight">{right}</div> : null}
    </div>
  );
}
